module.exports = __webpack_public_path__ + "static/7-1229bfa70e0b3092e3420b928ca74771.png";